import React, { useState, useEffect, useRef } from 'react';
import { getVentesByUser, clearVentes, getLivraisonsForCommission } from '../../flux/actions/venteActions';
import { getAssociationsByUser, clearAssociations, getLivraisonsAForCommission } from '../../flux/actions/associationActions';
import { getEncaissementsForCommission } from '../../flux/actions/encaissementActions';
import { getGoals, addOrEditGoal } from '../../flux/actions/goalActions';
import { getGoal_societe_defaults, addOrEditGoal_societe_default } from '../../flux/actions/goalsocietedefaultActions';
import { getVentesByIdsPromise } from '../../flux/actions/venteActions';
import { getAssociationsByIdsPromise } from '../../flux/actions/associationActions';
import { getEncaissementsByIdsPromise } from '../../flux/actions/encaissementActions';
import { Container, Row, Col, Label, Input, Button, CustomInput, FormGroup, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalHeader, ModalBody, Collapse, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import VenteListModal from '../modals/VenteListModal';
import EncaissementListModal from '../modals/EncaissementListModal';
import { connect } from 'react-redux';
import { IGoalCardContainer, IGoalCardReduxProps, ICommission_history, ITarget } from '../../types/interfaces';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { PRIVILEGE } from '../../types/privileges'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faHouseUser, faUserTag, faAngleDoubleDown, faMoneyCheckAlt, faWallet, faBullseye, faExclamationCircle, faCalculator, faEdit, faCircle, faCheck, faTimes, faSearch, faCheckCircle, faSpinner, faPen, faCheckSquare, faAngleDown, faAngleUp, faList, faFolderPlus, faUser, faCaretLeft, faCaretRight, faCommentDots, faCalendarAlt, faTrash, faThumbtack, faCheckDouble, faListUl, faDownload, faPrint } from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import Durations from '../Durations';
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants';
import { useParams } from "react-router-dom";
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import moment from 'moment';
import DatePicker from "reactstrap-date-picker";
// ChartJS.register(ArcElement, Tooltip, Legend);
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import MonthPicker from 'react-month-picker'
import { betterTypeName } from '../../services/formatting';
import { instantPrint } from '../pdf/PDFLink';
import { useBeforeunload } from 'react-beforeunload'
import { useReactToPrint } from 'react-to-print';
import Construction from '../Construction';
import { getColorBudget } from '../../services/misc';

const GoalCardContainerComponent = ({
  getVentesByUser,
  clearVentes,
  getAssociationsByUser,
  clearAssociations,
  getGoals,
  getGoal_societe_defaults,
  vente,
  association,
  goal,
  goal_societe_default,
  selectedUser,
  societeValue,
  monthPickerValue,
  users,
  loadingU,
  auth
 }: IGoalCardContainer) => {
  let { project: projectIdTarget, user: userIdTarget } = useParams();
  const alert = useAlert();

  const { ventes, loading } = vente;
  const { associations, loading: loadingA } = association;
  const { goals, loading: loadingG } = goal;
  const { goal_societe_defaults, loading: loadingGSD } = goal_societe_default;

  const [allEncaissements, setAllEncaissements] = useState<any>([]);
  const [livraisonLines, setLivraisonLines] = useState<any>([]);
  const [livraisonLinesA, setLivraisonLinesA] = useState<any>([]);
  const [loadingE, setLoadingE] = useState(false);
  const [loadingL, setLoadingL] = useState(false);
  const [loadingLA, setLoadingLA] = useState(false);
  const [ventesAndAssociations, setVentesAndAssociations] = useState<any[]>([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))].sort((a, b) => {
    if(!a.createdAt && !b.createdAt)
      return 0
    else if(!a.createdAt)
      return 1
    else if(!b.createdAt)
      return -1
    else
      return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
  }));;
  const [goalPrixNet, setGoalPrixNet] = useState<any>(undefined);
  const [goalEncaissements, setGoalEncaissements] = useState<any>(undefined);
  const [goalRecouvrement, setGoalRecouvrement] = useState<any>(undefined);
  const [goalLivraison, setGoalLivraison] = useState<any>(undefined);
  const sPrixNet = ventesAndAssociations.reduce((e, t) => e + Number((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0);
  const sLivraison = livraisonLines.reduce((e, t) => e + Number(t.PRIX_NET || 0), 0) + livraisonLinesA.reduce((e, t) => e + Number(t.PRIX_VENTE || 0), 0);
  const sVEncaissements = allEncaissements.filter(e => e.enc_supp !== 1).reduce((e, t) => e + Number(t.PART || 0), 0);
  const sREncaissements = allEncaissements.filter(e => e.enc_supp === 1).reduce((e, t) => e + Number(t.PART || 0), 0);
  const vIds = {venteIds: ventesAndAssociations.filter(e => !e.isAssLine).map(e => e.id), assIds: ventesAndAssociations.filter(e => !!e.isAssLine).map(e => e.id)}
  const eIds = allEncaissements.filter(e => e.enc_supp !== 1).map(e => e.encaissementId)
  const rIds = allEncaissements.filter(e => e.enc_supp === 1).map(e => e.encaissementId)
  const lIds = {venteIds: livraisonLines.map(e => e.id), assIds: livraisonLinesA.map(e => e.id)}
  // const lIds = livraisonLines.map(e => (e.isAssLine ? e.contrat : e)?.id)
  const remainingPrixNet = goalPrixNet - sPrixNet;
  const remainingVEncaissements = goalEncaissements - sVEncaissements;
  const remainingREncaissements = goalRecouvrement - sREncaissements;
  const remainingLivraison = goalLivraison - sLivraison;
  const titledOptions = [{value: "ALL", label: "Tout"}, {value: "TITLED", label: "Titrés"}, {value: "UNTITLED", label: "Non titrés"}];
  const [titledValue, setTitledValue] = useState<any>(titledOptions.find(e => e.value === "ALL"));
  const sNotaireOptions = [{value: "NOT YET", label: "Pas encore signé"}, {value: "CHEZ", label: "Signé client"}, {value: "EN COURS", label: "Signature en cours"}, {value: "SIGNE", label: "Signé notaire"}];
  const [sNotaireValues, setSNotaireValues] = useState<any[]>(sNotaireOptions);
  const [showAllAssociationsValue, setShowAllAssociationsValue] = useState(true);
  const [moreSettings, setMoreSettings] = useState(false);
  const today = new Date();
  const [selectedDuration, setSelectedDuration] = useState<any>('');

  const [goalsModal, setGoalsModal] = useState(false);
  const [goalsEditModal, setGoalsEditModal] = useState(false);
  const [goalsEditMonth, setGoalsEditMonth] = useState<any>(undefined);
  const chartRef = useRef(null);
  const [disablePrint, setDisablePrint] = useState(false);

  const [modalV, setModalV] = useState(false);
  const [modalE, setModalE] = useState(false);
  const [listVv, setListVv] = useState<any[]>([]);
  const [listVa, setListVa] = useState<any[]>([]);
  const [listE, setListE] = useState<any[]>([]);
  const [loadingVv, setLoadingVv] = useState(false);
  const [loadingVa, setLoadingVa] = useState(false);
  const [loadingEE, setLoadingEE] = useState(false);

  const getVv = (ids) => {
    setListVv([])
    setLoadingVv(true)
    getVentesByIdsPromise(ids || [])
    .then(e => setListVv(e || []))
    .finally(() => setLoadingVv(false))
  };

  const getVa = (ids) => {
    setListVa([])
    setLoadingVa(true)
    getAssociationsByIdsPromise(ids || [])
    .then(e => setListVa(e || []))
    .finally(() => setLoadingVa(false))
  };

  const getE = (ids) => {
    setListE([])
    setLoadingEE(true)
    getEncaissementsByIdsPromise(ids || [])
    .then(e => setListE(e || []))
    .finally(() => setLoadingEE(false))
  };

  // const getE = (ids) => {
  //   setListE(encaissements.filter(e => e.id && (ids || []).includes(e.id)))
  // };
  
  const handleToggleGoals = () => setGoalsModal(!goalsModal);

  const getGoalsFromDateProjUser = (userId: number, societeId: any, month: number, year: number) => {
    let res: any = goals.find(e => e.comId === userId && e.societeId === societeId && e.month === month && e.year === year);
    if(!res)
      res = goal_societe_defaults.find(e => e.societeId === societeId && e.month === month && e.year === year)
    
    return res
  }

  const getGoalsFromDateMain = (selectedUser: any, societeValue: any, month: number, year: number) => {
    if(selectedUser && societeValue && societeValue?.id !== "ALL")
      return getGoalsFromDateProjUser(selectedUser.id, societeValue.id, month, year)
    return undefined
  }

  useEffect(() => {
    if(selectedUser?.id === "ALL"){
      if(societeValue?.id === "ALL"){
        const goalsFromDateMainUsers = (auth?.user?.societes || []).reduce((e, t) => [...e, ...users.map(n => getGoalsFromDateMain(n, t, today.getMonth() + 1, today.getFullYear()))], [] as any[]).filter(e => !!e);
        setGoalPrixNet(goalsFromDateMainUsers.reduce((e, t) => e + Number(t.goalV || 0), 0))
        setGoalEncaissements(goalsFromDateMainUsers.reduce((e, t) => e + Number(t.goalE || 0), 0))
        setGoalRecouvrement(goalsFromDateMainUsers.reduce((e, t) => e + Number(t.goalR || 0), 0))
        setGoalLivraison(goalsFromDateMainUsers.reduce((e, t) => e + Number(t.goalL || 0), 0))
      }
      else{
        const goalsFromDateMainUsers = users.map(e => getGoalsFromDateMain(e, societeValue, today.getMonth() + 1, today.getFullYear())).filter(e => !!e);
        setGoalPrixNet(goalsFromDateMainUsers.reduce((e, t) => e + Number(t.goalV || 0), 0))
        setGoalEncaissements(goalsFromDateMainUsers.reduce((e, t) => e + Number(t.goalE || 0), 0))
        setGoalRecouvrement(goalsFromDateMainUsers.reduce((e, t) => e + Number(t.goalR || 0), 0))
        setGoalLivraison(goalsFromDateMainUsers.reduce((e, t) => e + Number(t.goalL || 0), 0))
      }
    }
    else{
      if(societeValue?.id === "ALL"){
        const goalsFromDateMainSocietes = (auth?.user?.societes || []).map(e => getGoalsFromDateMain(selectedUser, e, today.getMonth() + 1, today.getFullYear())).filter(e => !!e);
        setGoalPrixNet(goalsFromDateMainSocietes.reduce((e, t) => e + Number(t.goalV || 0), 0))
        setGoalEncaissements(goalsFromDateMainSocietes.reduce((e, t) => e + Number(t.goalE || 0), 0))
        setGoalRecouvrement(goalsFromDateMainSocietes.reduce((e, t) => e + Number(t.goalR || 0), 0))
        setGoalLivraison(goalsFromDateMainSocietes.reduce((e, t) => e + Number(t.goalL || 0), 0))
      }
      else{
        const goalsFromDateMain = getGoalsFromDateMain(selectedUser, societeValue, today.getMonth() + 1, today.getFullYear());
        setGoalPrixNet(goalsFromDateMain?.goalV);
        setGoalEncaissements(goalsFromDateMain?.goalE);
        setGoalRecouvrement(goalsFromDateMain?.goalR);
        setGoalLivraison(goalsFromDateMain?.goalL);
      }
    }
  }, [selectedUser, societeValue, goals, goal_societe_defaults])

  useEffect(() => {
    setVentesAndAssociations([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))]
    .filter(e => sNotaireValues.some(e => e.value === "NOT YET") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !!(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !!(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "CHEZ") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || (e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "EN COURS") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]))
    .filter(e => sNotaireValues.some(e => e.value === "SIGNE") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) !== constants.STATUT_SIGNE_NOTAIRE)
      // .filter(e => includeSigneNotaire || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) !== constants.STATUT_SIGNE_NOTAIRE)
      .filter(e => (e["isAssLine"] ? e["contrat"]?.PROJET : e.PROJET) !== "CM3" && (e["isAssLine"] ? e["contrat"]?.PROJET : e.PROJET) !== "CM3 SOCIAL")
      .sort((a, b) => {
      if(!a.createdAt && !b.createdAt)
        return 0
      else if(!a.createdAt)
        return 1
      else if(!b.createdAt)
        return -1
      else
        return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
    }))
  }, [ventes, associations, sNotaireValues])

  const changeShowAllAssociationsHandle = (e) => {
    setShowAllAssociationsValue(e.target.checked);
  };

  useEffect(() => {
    if(selectedUser)
      getGoals(selectedUser?.id);
  }, [getGoals, selectedUser])

  useEffect(() => {
    getGoal_societe_defaults();
  }, [getGoal_societe_defaults])

  useEffect(() => {
    setSelectedDuration({
      from: moment({month: monthPickerValue.month - 1, year: monthPickerValue.year}).startOf('month'),
      to: moment({month: monthPickerValue.month - 1, year: monthPickerValue.year}).endOf('month'),
      isCustom: true
    });
  }, [monthPickerValue])
  
  useEffect(() => {
    clearVentes();
    clearAssociations();
    setAllEncaissements([]);
    setLivraisonLines([]);
    setLivraisonLinesA([]);
    if(societeValue && auth?.user && selectedUser && !loadingU){
      getVentesByUser(selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], showAllAssociationsValue ? 1 : 0, societeValue["id"] === "ALL" ? "ALL" : societeValue["id"], societeValue["LIBELE"], auth?.user.societes || [], (titledValue || titledOptions[1]).value, 1);
      if(showAllAssociationsValue)
        getAssociationsByUser(selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], societeValue["id"] === "ALL" ? "ALL" : societeValue["id"], societeValue["LIBELE"], auth?.user.societes || [], (titledValue || titledOptions[1]).value, 1);
      setLoadingE(true)
      setLoadingL(true)
      setLoadingLA(true)
      getEncaissementsForCommission(selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], societeValue["id"] === "ALL" ? "ALL" : societeValue["id"], societeValue["LIBELE"], auth?.user.societes || [], (titledValue || titledOptions[1]).value).then(e => {
        setAllEncaissements(e || []);
      }).finally(() => setLoadingE(false))
      getLivraisonsForCommission(selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], societeValue["id"] === "ALL" ? "ALL" : societeValue["id"], societeValue["LIBELE"], auth?.user.societes || [], (titledValue || titledOptions[1]).value).then(e => {
        setLivraisonLines(e || []);
      }).finally(() => setLoadingL(false))
      getLivraisonsAForCommission(selectedDuration, selectedUser.id === "ALL" ? ((auth?.user?.privileges?.includes(PRIVILEGE.ACCESS_ALL_USERS) ? users : auth.user.underlings)?.map(e => e.id) || []) : [selectedUser.id], societeValue["id"] === "ALL" ? "ALL" : societeValue["id"], societeValue["LIBELE"], auth?.user.societes || [], (titledValue || titledOptions[1]).value).then(e => {
        setLivraisonLinesA(e || []);
      }).finally(() => setLoadingLA(false))
    }
  }, [societeValue, auth, selectedDuration, titledValue, selectedUser, showAllAssociationsValue/*, users, loadingU*/]);

  useEffect(() => {
    return () => {
      clearVentes();
      clearAssociations();
      setAllEncaissements([]);
      setLivraisonLines([]);
      setLivraisonLinesA([]);
    }
  }, []);

  const handleTitledChange = data => {
    setTitledValue(data || '');
  }
  const handleSNotaireChange = data => {
    setSNotaireValues(data?.length ? data : []);
  }

  const downloadChart = chartRef => {
    if (chartRef.current) {
      const datetimeAsText = new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear() + '_' + new Date().getHours() + '-' + new Date().getMinutes() + '-' + new Date().getSeconds();
      try{
        const base64 = chartRef.current.toBase64Image();
        const downloadLink = document.createElement("a");
        downloadLink.href = base64;
        downloadLink.download = `${"chart"}_${datetimeAsText}`;
        downloadLink.click();
      }
      catch(e){
        console.error("error downloading enc image")
      }
    }
  }

  const printChart = chartRef => {
    if (chartRef.current) {
      const url = chartRef.current.toBase64Image();
      const printWindow = window.open(url);
      if(printWindow){
        printWindow.document.write('<img src="' + url + '" onload="window.print();window.close()" />');
        printWindow.focus();
      }
    }
  }

  return !auth?.user ? <LoadingPage/> : (
    <>
      <div className="moreSettings" style={{padding: 0, fontSize: "small"}}>
        <p onClick={() => setMoreSettings(e => !e)} style={{marginBottom: "5px"}}><FontAwesomeIcon icon={faAngleDoubleDown} className={`flipIcon${moreSettings ? " flipped" : ""}`} />&nbsp;&nbsp;Plus de paramètres</p>
      </div>
      <Collapse className="mb-2" isOpen={moreSettings}>
        <Row className="justify-content-between">
          <Col xs="12" lg="6" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="snotaire">Statut notaire : </Label>
            </div>
            <Select
              id="snotaire"
              className="reactselect"
              classNamePrefix="react-select"
              isMulti
              value={sNotaireValues?.map(e => ({label: e.label, value: e.value})) || []}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleSNotaireChange}
              placeholder={'Chercher...'}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              options={sNotaireOptions}
              menuContainerStyle={{ zIndex: 9999999 }}
            />
          </Col>
          <Col xs="12" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="titled">Titrés : </Label>
            </div>
            <Select
              id="titled"
              className="reactselect"
              classNamePrefix="react-select"
              defaultValue={titledOptions[1]}
              value={titledValue}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleTitledChange}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={false}
              options={titledOptions}
            />
          </Col>
          <Col xs="12" lg="3" className="fullFlexCenter">
            <CustomInput type="switch" id="showAllAssociations" name="showAllAssociationsSwitch" label="Afficher les parts des associations" checked={showAllAssociationsValue} onChange={changeShowAllAssociationsHandle} />
          </Col>
        </Row>
      </Collapse>
      {loading || loadingA || loadingE || loadingL || loadingLA || loadingG ? <Loading topSpace /> : <Row className="justify-content-center">
        <Col xs="12" md="9">
          <div className="scanPreviewBtnsAndImgContainer">
            <Bar data={{
              labels: ["Ventes", "Encais. Ventes", "Recouvrement", "Livraison"],
              datasets: [
                {
                  label: "Objectif (DH)",
                  data: [goalPrixNet, goalEncaissements, goalRecouvrement, goalLivraison],
                  backgroundColor: "brown",
                },
                {
                  label: "Réalisé (DH)",
                  data: [sPrixNet, sVEncaissements, sREncaissements, sLivraison],
                  backgroundColor: "#45772e",
                  // backgroundColor: ["#45772eee", "#2a739fee", "#6495edee", "#2f4f4fee"],
                },
              ],
            }} options={{
              scales: {
                x: {
                  beginAtZero: true,
                },
              },
              plugins: {
                legend: {
                  display: true
                },
                title: {
                  display: true,
                  text: `Objectif ${selectedUser?.LOGIN || ""} (${societeValue?.LIBELE || ""}) ${monthPickerValue ? constants.DP_MONTHS[monthPickerValue?.month - 1] : ""} ${monthPickerValue?.year || ""}`,
                },
              },
              animation: {
                duration: 0
              },
              indexAxis: 'x',
              elements: {
                bar: {
                  borderWidth: 2,
                },
              },
              responsive: true,
            }} ref={chartRef} />
            <div className="scanPreviewBtnsContainer">
              <button onClick={() => printChart(chartRef)} title="Imprimer" disabled={disablePrint}><FontAwesomeIcon icon={disablePrint ? faSpinner : faPrint} className={disablePrint ? "spinner" : ""} /></button>
              <button onClick={() => downloadChart(chartRef)} title="Télécharger"><FontAwesomeIcon icon={faDownload} /></button>
            </div>
          </div>
        </Col>
        <Col xs="12" md="3">
          <div className="goalBoxes">
            {/* <div className="goalBoxInfo">
              <h5>Ventes</h5>
              <div><FontAwesomeIcon icon={faMoneyCheckAlt} style={{color: "#45772e"}} />&nbsp;<strong>Réalisé : </strong>{sPrixNet.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH {!!goalPrixNet && <span className="encPercent" style={{color: getColorBudget((sPrixNet * 100) / goalPrixNet)}}>({Math.ceil((sPrixNet * 100) / goalPrixNet)}%)</span>}</div>
              <div><FontAwesomeIcon icon={faBullseye} style={{color: "brown"}} />&nbsp;<strong>Objectif : </strong>{!!goalPrixNet ? `${goalPrixNet.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH` : "-"}</div>
            </div> */}
            {[
              {title: "Ventes", color: "#45772e", fulfilled: sPrixNet, goal: goalPrixNet, getData: () => {getVv(vIds?.venteIds || []); getVa(vIds?.assIds || []); setModalV(true);}},
              {title: "Encais. Ventes", color: "#2a739f", fulfilled: sVEncaissements, goal: goalEncaissements, getData: () => {getE(eIds || []); setModalE(true);}},
              {title: "Recouvrement", color: "cornflowerblue", fulfilled: sREncaissements, goal: goalRecouvrement, getData: () => {getE(rIds || []); setModalE(true);}},
              {title: "Livraison", color: "darkslategray", fulfilled: sLivraison, goal: goalLivraison, getData: () => {getVv(lIds?.venteIds || []); getVa(lIds?.assIds || []); setModalV(true);}},
            ].map((e, key) => <div className="goalBoxInfo" key={key}>
              <h5 className="goalBoxTitle" style={{backgroundColor: e.color}}>{e.title}</h5>
              <div className="goalBoxTextContainer">
                <div><FontAwesomeIcon icon={faBullseye} style={{color: "brown"}} />&nbsp;<strong>Objectif : </strong>{!!e.goal ? `${e.goal.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH` : "-"}</div>
                <div><FontAwesomeIcon icon={faMoneyCheckAlt} style={{color: "#45772e"}} />&nbsp;<strong>Réalisé : </strong>{e.fulfilled.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH {!!e.goal && <span className="encPercent" style={{color: getColorBudget((e.fulfilled * 100) / e.goal)}}>({Math.ceil((e.fulfilled * 100) / e.goal)}%)</span>}&nbsp;<FontAwesomeIcon icon={faList} className="monthCardBtnIcon monthCardEdit" title="Voir la liste détaillée" style={{color: "chocolate", position: "static"}} onClick={() => {e.getData()}} /></div>
              </div>
            </div>)}
          </div>
        </Col>
      </Row>}
      <VenteListModal modal={modalV} setModal={setModalV} lines={[...listVv, ...listVa.map(e => ({...e, vente: e.contrat, isAssLine: true}))].sort((a, b) => {
        if(!a.createdAt && !b.createdAt)
          return 0
        else if(!a.createdAt)
          return 1
        else if(!b.createdAt)
          return -1
        else
          return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
      })} linesLoading={loadingVv || loadingVa} />
      <EncaissementListModal modal={modalE} setModal={setModalE} lines={listE} linesLoading={loadingEE} />
    </>
  );
};

const mapStateToProps = (state: IGoalCardReduxProps) => ({
  vente: state.vente,
  association: state.association,
  goal: state.goal,
  goal_societe_default: state.goal_societe_default,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getVentesByUser, clearVentes, getAssociationsByUser, clearAssociations, getGoals, getGoal_societe_defaults })(GoalCardContainerComponent);
